import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { TaskQueueModel } from '@smarttask-common/src/lib/models/Record/Task/Queue/TaskQueueModel';

export enum TaskQueueActionTypes {
    ADD_QUEUE = '[TaskQueue] Create TaskQueue',
    ADD_QUEUES = '[TaskQueue] Add TaskQueues',
    UPSERT_QUEUE = '[TaskQueue] Upsert TaskQueue',
    UPSERT_QUEUES = '[TaskQueue] Upsert TaskQueues',
    UPDATE_QUEUE = '[TaskQueue] Update TaskQueue',
    UPDATE_QUEUES = '[TaskQueue] Update TaskQueues',
    DELETE_QUEUE = '[TaskQueue] Delete TaskQueue',
    DELETE_QUEUES = '[TaskQueue] Delete TaskQueues',
    DELETE_ALL_QUEUES = '[TaskQueue] Delete All TaskQueues',
    DELETE_ALL = '[TaskQueue] Delete All',

    UPDATE_SELECTED_ID = '[TaskQueue] Update SelectedId',
}

export class UpdateSelectedTaskQueueId implements Action {
    readonly type = TaskQueueActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_id: string) {}
}

export class AddOne implements Action {
    readonly type = TaskQueueActionTypes.ADD_QUEUE;
    constructor(public queue_item: TaskQueueModel) {}
}

export class AddMany implements Action {
    readonly type = TaskQueueActionTypes.ADD_QUEUES;
    constructor(public queue: Array<TaskQueueModel>) {}
}

export class UpsertOne implements Action {
    readonly type = TaskQueueActionTypes.UPSERT_QUEUE;

    constructor(public queue_item: TaskQueueModel) {}
}

export class UpsertMany implements Action {
    readonly type = TaskQueueActionTypes.UPSERT_QUEUES;
    constructor(public queue: Array<TaskQueueModel>) {}
}

export class UpdateOne implements Action {
    readonly type = TaskQueueActionTypes.UPDATE_QUEUE;
    constructor(public queue_item: Update<TaskQueueModel>) {}
}

export class UpdateMany implements Action {
    readonly type = TaskQueueActionTypes.UPDATE_QUEUES;
    constructor(public queue: Array<Update<TaskQueueModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = TaskQueueActionTypes.DELETE_QUEUE;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = TaskQueueActionTypes.DELETE_QUEUES;
    constructor(public ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = TaskQueueActionTypes.DELETE_ALL_QUEUES;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = TaskQueueActionTypes.DELETE_ALL;
    constructor() {}
}

export type TaskQueueActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedTaskQueueId;
